export enum DocumentStatus {
  METADATA_INSPECTION = 'metadata_inspection',
  FORMAL_CONTROL = 'formal_control',
  QUALITY_CHECK = 'quality_check',
  RECORD_LIBRARY_TRANSFER_IN_PROGRESS = 'record_library_transfer',
  RECORD_LIBRARY_TRANSFER_SUCCESSFULL = 'record_library_transfer_successfull',
  RECORD_LIBRARY_TRANSFER_FAILED = 'record_library_transfer_failed',
}
